/// <summary>
/// SDK的入口API
/// </summary>

import Util from "@/Master/Util";
import {KitConst} from "./KitConst";
import KitLog from "./KitLog";
import GoogleTrack from "@/Fwk/Kit/GoogleTrack";
import KitCfg from "@/Fwk/Kit/KitCfg";
import {KitBehaviour} from "./KitBehaviour";
import {KitSp} from "./KitSp";
import KitAB from "@/Fwk/Kit/AB/KitAB";
import {WebPlatform} from "./Platform/WebPlatform";
import {KitTrack} from "@/Fwk/Kit/Track/KitTrack";
import {KitAdjust} from "@/Fwk/Kit/Adjust/KitAdjust";
import {KitIAP} from "@/Fwk/Kit/Iap/KitIap";
import {AppConfig} from "@/app/config/AppConfig";
import {JsonData} from "@/Fwk/Kit/JsonData";
import {RecodeKey} from "@/Fwk/Kit/Track/TrackConst";
import {confJson} from "@/app/config/confJson";

/// <author>xiexingwu</author>
export default class KitAPI {
    static IS_ANDROID: false;
    static IS_IOS = false;
    static IS_WEB = true;
    static IS_UNITY = !(KitAPI.IS_ANDROID || KitAPI.IS_IOS || KitAPI.IS_WEB);
    // static string persistentDataPath = Application.persistentDataPath;
    static dpi = "0";
    static _platform: IPlatform;
    private static HadInit: boolean = false;

    private static cofigAsset = "";
    private static cofig210Asset = "";

    public static Init(asset: string, asset210: string, isSilentAB: boolean, isSilentTrack: boolean, isSilentIAP: boolean): void {
        if (KitAPI.HadInit) {
            if (KitLog.IsLog) KitLog.Log("重复初始化");
            return;
        }

        KitAPI.cofigAsset = asset;
        KitAPI.cofig210Asset = asset210;

        KitBehaviour.Init();
        GoogleTrack.InitSdk();
        KitSp.Init();
        //1、统计初始化
        KitTrack.Init(isSilentTrack);
        //2、AB初始化
        KitAB.Init(isSilentAB);
        //3、归因初始化
        KitAdjust.Init(()=>{KitAB.AttributionChanged()});
        //4、风控初始化
        KitIAP.Init(isSilentIAP);


        this.GetPlatForm().InitForterSDK(KitCfg.OptString("forterId"));
        KitAPI.HadInit = true;
    }

    private static GetPlatForm(): IPlatform {
        if (KitAPI._platform == null) {
            KitAPI._platform = new WebPlatform();
        }
        return KitAPI._platform;
    }

    static IsNetworkOk(): boolean {
        return this.GetPlatForm().IsNetworkOk();
    }

    static isVpnConnected(): boolean {
        return this.GetPlatForm().isVpnConnected();
    }

    static isWifiProxy(): boolean {
        return this.GetPlatForm().isWifiProxy();
    }

    static GetNetworkType(): string {
        return KitAPI.GetPlatForm().GetNetworkType();
    }

    static GetConfig(): string {
        return KitCfg.jsonString;
    }


    private static _testConfig: string;

    static get testConfig(): string {
        if (KitAPI._testConfig) return KitAPI._testConfig;
        KitAPI._testConfig = KitAPI.GetPlatForm().GetTestConfig();
        // Debug.Log($"{KitLog.LogTag} tc  return  {_testConfig}");//这里不能用KitLog,防止递归
        return KitAPI._testConfig;
    }

    static _testConfigJson: JsonData;
    static get testConfigJson(): JsonData {
        if (!KitAPI._testConfigJson) {
            KitAPI._testConfigJson = new JsonData(null, KitAPI.testConfig);
        }
        return KitAPI._testConfigJson
    }

    static IsTest(key: string): boolean {
        return KitAPI.testConfigJson.OptBoolean(key);
    }

    static GetConfigAsset(): [boolean, string] {
        //测试文件
        const IsTest210 = KitAPI.IsTest("test210");
        const isTestProduct = KitAPI.GetPlatForm().IsTestProduct();
        const isTest = IsTest210 && isTestProduct;
        const platCfg = KitAPI.GetPlatForm().GetCfg();
        const asset = isTest ? KitAPI.cofig210Asset : KitAPI.cofigAsset;
        if (KitLog.IsLog) {
            KitLog.Log(`产品配置:测试文件:IsTest210=${IsTest210},打包配置:isTestProduct=${isTestProduct}`);
            if (asset == null && !platCfg) {
                KitLog.LogWarning(
                    "产品配置:配置为NULL,请检查确保已经调用:KitProxy.Init(cofigAsset,cofig210Asset)," +
                    "确保参数中传入配置参数是否为NULL。或者平台端是否提供外部配置config获取接口。");
            }
        }
        return [isTest, platCfg ? platCfg : asset];
    }

    static GetIpAddress(): string {
        return KitAPI.GetPlatForm().GetDeviceIpAddress();
    }

    static LocalCountry(): string {
        return "";
    }

    static IsVirLoc(): boolean {
        return KitAPI.GetPlatForm().IsVirLoc();
    }

    static SSID(): string {
        return KitAPI.GetPlatForm().GetSSID();
    }

    static MAC(): string {
        return KitAPI.GetPlatForm().GetMAC();
    }

    /// <summary>
    /// 检查Id的合法性
    /// </summary>
    /// <param name="id"></param>
    /// <returns></returns>
    private static CheckId(id: string | undefined): boolean {
        return id != undefined && id != "00000000-0000-0000-0000-000000000000";
    }


    private static _IDFV: string;

    static get IDFV(): string {
        if (this.CheckId(this._IDFV)) return this._IDFV;
        const key = KitConst.idfv;
        let id = KitSp.GetString(key, "");
        if (id == null) {
            id = this.GetPlatForm().GetIdfv();
            id ??= "";
        }

        if (this.CheckId(id)) {
            KitSp.SetString(key, id);
            KitSp.Apply();
        }

        this._IDFV = id;
        return this._IDFV;

    }

    private static _ADID: string;

    static get ADID(): string {
        if (this.CheckId(this._ADID)) return this._ADID;
        const key = KitConst.adid;
        let id = KitSp.GetString(key, "");
        if (id == "") {
            id = this.GetPlatForm().GetGAID();
            id ??= "";
        }

        if (this.CheckId(id)) {
            KitSp.SetString(key, id);
            KitSp.Apply();
        }

        this._ADID = id;
        return this._ADID;
    }

    private static _UUID: string;

    static get UUID(): string {
        if (this._UUID) return this._UUID;
        // 生成一个新的UUID
        const id = Util.h5UUID;
        KitSp.SetString(KitConst.uuid, id);
        KitSp.Apply();
        this._UUID = id;
        return this._UUID;
    }


    static ElapsedRealtime(): number {
        return this.GetPlatForm().GetElapsedRealtime();
    }


    /// <summary>
    /// 日期对象转时间戳，毫秒为单位
    /// </summary>
    /// <param name="date"></param>
    /// <returns></returns>
    public static GetNowSeconds(): number {
        return new Date().getSeconds();
    }

    /// <summary>
    /// 日期对象转时间戳，毫秒为单位
    /// </summary>
    /// <param name="date"></param>
    /// <returns></returns>
    public static GetNowMills(): number {
        return new Date().getTime();
    }

    private static _versionCode: number;

    static get versionCode(): number {
        if (this._versionCode > 0) {
            return this._versionCode;
        }
        this._versionCode = this.GetPlatForm().GetVersionCode();
        return this._versionCode;
    }

    private static _versionName: string;

    static get versionName(): string {
        if (this._versionName != null) return this._versionName;
        this._versionName = this.GetPlatForm().GetVersionName();
        return this._versionName;
    }

    private static _appName: string;

    static get appName(): string {
        if (this._appName) return this._appName;
        this._appName = this.GetPlatForm().GetAppLabel();
        return this._appName;
    }

    private static _packageName: string;

    static get packageName(): string {
        if (this._packageName) return this._packageName;
        // this._packageName = this.GetPlatForm().GetPackageName();
        this._packageName = confJson.h5_package_name;
        return this._packageName;
    }

    private static _country: string;

    static get country(): string {
        if (!this._country) return this._country;
        this._country = this.GetPlatForm().GetCountryCode();
        return this._country;
    }


    private static _language: string;

    static get language(): string {
        if (this._language) return this._language;
        this._language = this.GetPlatForm().GetLanguage();
        return this._language;
    }

    private static _firstActviteTime: number;

    static get firstActviteTime(): number {
        if (this._firstActviteTime != 0) return this._firstActviteTime;
        const ls = KitSp.GetString(KitConst.actvite_time, "");
        let time = +ls;
        if (!isNaN(time)) {
            time = this.GetNowMills();
            KitSp.SetString(KitConst.actvite_time, time.toString());
            KitSp.Apply();
        }

        this._firstActviteTime = time;
        return this._firstActviteTime;
    }


    static GetActviteDay(): number {
        const nowMills = this.GetNowMills();
        let days = 1;
        if (nowMills <= this.firstActviteTime) {
            return days; //当头，或者调时间到前面
        }

        days = (nowMills - this.firstActviteTime) / (24 * 60 * 60 * 1000);
        days++;

        if (days < 1) days = 1;

        return days;
    }


    static GetActviteHours(): number {
        var nowMills = this.GetNowMills();
        let hours = 1;
        if (nowMills <= this.firstActviteTime) {
            return hours; //当头，或者调时间到前面
        }

        hours = (nowMills - this.firstActviteTime) / (60 * 60 * 1000);
        hours++;

        if (hours < 1) hours = 1;

        return hours;
    }


    private static _firstActviteVersionCode: number;

    static get firstActviteVersionCode(): number {
        if (this._firstActviteVersionCode != 0) return this._firstActviteVersionCode;
        this._firstActviteVersionCode = KitSp.GetInt("firstActviteVersionCode", 0);
        if (this._firstActviteVersionCode == 0) {
            this._firstActviteVersionCode = this.versionCode;
            KitSp.SetInt("firstActviteVersionCode", this._firstActviteVersionCode);
            KitSp.Apply();
        }

        return this._firstActviteVersionCode;
    }

    private static _osVersion: string;

    static get osVersion(): string {
        if (this._osVersion != null) return this._osVersion;
        this._osVersion = this.GetPlatForm().GetOsVersion();
        return this._osVersion;
    }

    private static _osBrand: string;

    static get osBrand(): string {
        if (this._osBrand != null) return this._osBrand;
        this._osBrand = this.GetPlatForm().GetOsBrand();
        return this._osBrand;
    }


    private static _osModel: string;

    static get osModel(): string {
        if (this._osModel != null) return this._osModel;
        this._osModel = this.GetPlatForm().GetOsModel();
        return this._osModel;
    }

    private static _deviceType: string;

    static get deviceType(): string {
        if (this._deviceType != null) return this._deviceType;
        this._deviceType = (this.osBrand + " " + this.osModel).trim();
        if (this._deviceType == " ") this._deviceType = "";
        return this._deviceType;
    }

    private static _osType: string;

    static get osType(): string {
        if (this._osType != null) return this._osType;
        if (this.IS_ANDROID) this._osType = KitConst.android;
        else if (this.IS_IOS) this._osType = KitConst.IOS;
        // else if (this.IS_WEB) _osType = KitConst.WEB;
        else if (this.IS_WEB) this._osType = KitConst.android;
        else this._osType = "";
        return this._osType;
    }

    private static _osIntType = -1;

    static get osIntType(): number {
        if (this._osIntType != -1) return this._osIntType;
        if (this.IS_ANDROID) this._osIntType = 1;
        else if (this.IS_IOS) this._osIntType = 2;
        // else if (IS_WEB) this._osIntType = 3;
        else if (this.IS_WEB) this._osIntType = 1;
        else this._osIntType = 0;
        return this._osIntType;

    }

    private static _MCC = "-1";

    static get MCC(): string {
        if (this._MCC !== "-1") return this._MCC;
        this._MCC = this.GetPlatForm().GetMcc();
        return this._MCC;
    }

    /// <summary>
    /// 是否打开开发者模式
    /// </summary>
    /// <returns>是：true 否：false</returns>
    static IsOpenDevelopmentSetting(): boolean {
        return this.GetPlatForm().IsOpenDevelopmentSetting();
    }

    /// <summary>
    /// 是否打开usb debug用户
    /// </summary>
    /// <returns>是：true 否：false</returns>
    static IsOpenedUSBDebug(): boolean {
        return this.GetPlatForm().IsOpenedUSBDebug();
    }

    private static _userId: string;
    static get userId(): string {
        if (this._userId != null) return this._userId;
        this._userId = KitSp.GetString(KitConst.user_id);
        return this._userId;
    }

    static set userId(value: string) {
        if (this._userId === value) return;
        this._userId = value;
        KitSp.SetString(KitConst.user_id, value);
        KitSp.Apply();
        if (KitLog.IsLog) KitLog.Log(`设置UserId:${value}`);
        KitAB.ForceRequst();
    }

    private static _notchScree: number | undefined = undefined;

    public static get notchScree(): number {
        if (this._notchScree != undefined) return this._notchScree;
        this._notchScree = this.GetPlatForm().GetNotchScree();
        return this._notchScree;
    }

    private static _installer: string;

    static get installer(): string {
        if (this._installer != null) return this._installer;
        this._installer = this.GetPlatForm().getInstaller();
        return this._installer;
    }

    static get isUpdateUser(): boolean {
        return this.firstActviteVersionCode != this.versionCode;
    }

    static StoreClipboard(text: string) {
        return this.GetPlatForm().StoreClipboard(text);
    }

    static JumpSettingConnect() {
        return this.GetPlatForm().JumpSettingConnect();
    }

    public static jump2URL(url: string): boolean {
        return this.GetPlatForm().Jump(KitConst.URL, url)
    }

    public static jump2PrivacyCenter(url: string): boolean {
        url = url ? KitCfg.privacy_url : url;
        return this.jump2URL(url);
    }

    public static jump2TermsUseCenter(url: string): boolean {
        url = url ? KitCfg.trems_url : url;
        return this.jump2URL(url);
    }

    public static sendFeedbackEmail(email: string = ""): boolean {
        if (email) email = KitCfg.mail;
        if (email) return false;
        //固定邮件模版格式（必要时可以改）
        const title = `[Feedback_${this.appName}_${this.versionName}]`;
        const content = `[${this.appName}]-[V${this.versionName}(${this.versionCode})_D${this.GetActviteDay()}]-[${this.osModel}_${this.osVersion}]`;

        // try
        // {    待实现
        //     Application.OpenURL("mailto:" + email + "?subject=" + title + "&body=" + content);
        //     return true;
        // }
        // catch (Exception)
        // {
        //     // ignored
        // }

        return false;
    }

    public static sendEmail(email: string = ""): boolean {
        if (email) email = KitCfg.mail;
        if (email) return false;
        try {
            // Application.OpenURL("mailto:" + email + "?subject=" + "" + "&body=" + "");
            // return true;
        } catch (Exception) {
            // ignored
        }

        return false;
    }

    public static jump2Amazon(): boolean {
        // if (IS_ANDROID) return launchApp("com.amazon.mShop.android.shopping");
        return false;
    }

    public static hasAmazon(): boolean {
        // if (IS_ANDROID) return hasInstalled("com.amazon.mShop.android.shopping");
        return false; //亚马逊应用商店只有Android平台
    }

    public static JumpToGooglePlay(): boolean {
        return this.GetPlatForm().JumpToAppStore();
    }

    public static JumpSamsungAppstore(): boolean {
        return this.GetPlatForm().JumpSamsungAppstore();
    }

    public static launchApp(strValue: string): boolean {
        return this.GetPlatForm().launchApp(strValue);
    }

    public static allowGameFun(): boolean {
        if (this.IsTest(KitConst.gameFun)) return true;
        return KitAB.allowGameFun();
    }

    public static hasInstalled(strValue: string): boolean {
        return this.GetPlatForm().hasInstalled(strValue);
    }

    public static getCurrentNtpTime(): number {
        if (this.IsTest(KitConst.abtest)) {
            if (KitLog.IsLog) KitLog.Log("getCurrentNtpTime:本地时间 ");
            return this.GetNowMills();
        }

        if (KitLog.IsLog) KitLog.Log("getCurrentNtpTime:服务器时间 ");
        return KitAB.curTime();
    }

    public static isUserBuy(): boolean {
        if (this.IsTest(KitConst.userBuy)) {
            return true;
        }

        return KitAdjust.IsBuyUserFlag();
    }

    public static IsSDKReady(): boolean {
        // if (this.IS_UNITY) return true;
        return KitAB.IsLoadingFinished();
    }

    public static GoogleGTMEvent(name: string, jsonStr: string) {
        return this.GetPlatForm().GoogleGTMEvent(name, jsonStr);
    }

    public static GetHeaderStr(): string {
        return JSON.stringify(this.GetHeader().jObject);
    }

    public static GetHeader(): JsonData {
        const head = new JsonData();
        head.put(KitConst.UUID, this.UUID);
        head.put(KitConst.PACKAGE_NAME, this.packageName);
        head.put(KitConst.OS_LANGUAGE, this.language);
        head.put(KitConst.COUNTRY, this.country);
        head.put(KitConst.SCREEN_HEIGHT, window.innerHeight);
        head.put(KitConst.SCREEN_WIDTH, window.innerWidth);
        head.put(KitConst.VERSION_NAME, this.versionName);
        head.put(KitConst.VERSION_CODE, this.versionCode);
        head.put(KitConst.OS_VERSION, this.osVersion);
        head.put(KitConst.OS, this.osType);
        head.put(KitConst.PHONE_MODEL, this.deviceType);
        head.put(KitConst.IMSI, "");
        head.put(KitConst.IMEI, "");
        head.put(KitConst.ANDROID_ID, this.UUID);
        head.put(KitConst.GOOGLE_AID, this.ADID);
        // if (this.IS_IOS) head.put(KitConst.IFA, this.ADID);
        // if (this.IS_IOS) head.put(KitConst.IDFV, this.IDFV);
        const smID = this.GetSmID();
        if (!smID) head.put(KitConst.TP_DEVICE_ID, smID); //数盟ID
        head.put(KitConst.IS_UPGRADE_USER, this.isUpdateUser);
        head.put(KitConst.NET, this.GetNetworkType());
        head.put(KitConst.INSTALL_DAYS, this.GetActviteDay());
        head.put(KitConst.INSTALL_HOURS, this.GetActviteHours());
        head.put(KitConst.PRODUCT_ID, KitCfg.productId);
        head.put(KitConst.RELEASE_PRODUCT_ID, KitCfg.releaseProductId);
        const mediaSource = KitAdjust.GetDistributor();
        head.put(KitConst.CHANNEL, mediaSource);
        head.put(KitConst.MEDIA_SOURCE, mediaSource);
        head.put(KitConst.CAMPAIGN, KitAdjust.GetSecondDistributor());
        head.put(KitConst.ADSET, KitAdjust.GetCreative());
        head.put(KitConst.ADGROUP, KitAdjust.GetAdGroup());
        head.put(KitConst.AB_TEST, KitAB.getAbGroupID());
        head.put(KitConst.USR_ABS, KitAB.getAbExperimentData());
        head.put(RecodeKey.H5_HOST_NAME, KitAPI.WebHotName);
        return head;
    }

    public static GetSmID(): string {
        return KitIAP.GetOrQuerySmID();
    }

    public static InitShuzilmSDK(appKey: string) {
        return this.GetPlatForm().InitShuzilmSDK(appKey);
    }

    public static QuerySmID(action: (id: string) => void) {
        return this.GetPlatForm().QuerySmID(action);
    }

    private static _isSimulator = -1;

    public static get isSimulator(): boolean {
        if (this._isSimulator != -1) return this._isSimulator == 1;
        if (this.GetPlatForm().isSimulator()) this._isSimulator = 1;
        else this._isSimulator = 0;
        return this._isSimulator == 1;
    }

    private static _isRoot = -1;

    public static get isRoot(): boolean {
        if (this._isRoot != -1) return this._isRoot == 1;
        if (this.GetPlatForm().isRoot()) this._isRoot = 1;
        else this._isRoot = 0;
        return this._isRoot == 1;
    }

    public static SetForterUserID(userId: string) {
        return this.GetPlatForm().SetForterUserID(userId);
    }

    public static GetForterJSCode(): string {
        return this.GetPlatForm().GetForterJSCode();
    }

    public static IsPWA(): boolean {
        return this.GetPlatForm().IsPWA();
    }

    public static IsInstalledPWA() {
        return this.GetPlatForm().IsInstalledPWA();
    }

    public static IsDesktopWeb() {
        return this.GetPlatForm().IsDesktopWeb();
    }

    public static IsIOSWeb() {
        return this.GetPlatForm().IsIOSWeb();
    }

    public static IsAndroidWeb(): boolean {
        return this.GetPlatForm().IsAndroidWeb();
    }

    public static InstallPWA() {
        this.GetPlatForm().InstallPWA();
    }

    private static _WebHotName: string;
    public static get WebHotName(): string {
        if (!this._WebHotName) return this._WebHotName;
        this._WebHotName = KitCfg.OptString("h5_host_name");
        return this._WebHotName;
    }
}